export default __webpack_public_path__ + "static/media/boo.1cb60b26.mp3";